const login = {
    existingUserEmail:false,
    isMissingPhone:null,
    isPrevPath:null,
    noPackageOrEvent:null,
    isInactiveUser:null
};

export default login;